import styles from "./PrimaryBtn.module.css";

const PrimaryBtn = (props) => {
  return (
    <button className={`${styles.btn} ${props.className}`}>
      {props.children}
    </button>
  );
};

export default PrimaryBtn;
